import { render } from "./TrainingsBlock.vue?vue&type=template&id=710fe1c6"
import script from "./TrainingsBlock.vue?vue&type=script&lang=js"
export * from "./TrainingsBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__